







import { Component, Vue, Watch } from 'vue-property-decorator';
import Api from '@/project/http/Api.service';
import ProductDetails from '@/project/product/product-details/ProductDetails.vue';
import productDetailsUrlService from './productDetailsUrl.service';
import { ProductDetailsViewModel } from '@/types/apiServerContract';
import appStore from '@/core/app/app.store';
import gtmService, { ProductTrackingState, TrackingProduct } from '@/project/tracking/gtm/GTM.service';
import { Route } from 'vue-router';
import domService from '@/core/dom/dom.service';
import errorCodeService from '@/core/errorCode.service';
import { NOT_FOUND } from 'http-status-codes';
import SpinnerOverlay from '@/project/spinners/SpinnerOverlay.vue';

@Component({
    components: { ProductDetails, SpinnerOverlay },
    beforeRouteEnter: (to: Route, from: Route, next) => {
        next();
    }
})
export default class ProductDetailsPage extends Vue {
    details: ProductDetailsViewModel | null = null;
    hasTrackedPage = false;
    loading: boolean = false;

    created() {
        this.setup();
    }

    @Watch('$route')
    onRouteChange(to: Route, from: Route) {
        if (to.path === from.path) return;
        this.setup();
    }

    async setup() {
        if (!this.hasTrackedPage && this.details) {
            gtmService.trackProductDetailsPage({
                ...this.details,
                stockInfo: null,
                price: undefined,
                trackingState: ProductTrackingState.NoErpResponseYet
            });
        }

        this.hasTrackedPage = false;
        const productWid = productDetailsUrlService.getProductWidFromUrl(this.$route.path);
        if (!productWid) return; // Probably because we're leaving page...

        this.loading = true;

        try {
            const result = await Api.product.details(productWid);
            this.details = Object.freeze(result);
            appStore.setBreadcrumb(result.breadCrumb);
        } catch (error) {
            appStore.setBreadcrumb([]);
            const logMessage = `ProductDetailsPage: A page with the following 'productWid' was not found: ${productWid}`;
            errorCodeService.handleErrorCodes(NOT_FOUND, logMessage, productWid);
        } finally {
            this.loading = false;
        }

        if (this.details?.alternativeUrls) {
            domService.setHreflang(this.details?.alternativeUrls);
        }
    }

    trackPage(product: TrackingProduct) {
        // Prices and stock ready
        gtmService.trackProductDetailsPage(product);
        this.hasTrackedPage = true;
    }
}
